import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { markNotificationsAsRead } from '@/features/notifications/api/mark-notifications-as-read';

type Props = Omit<
  UseMutationOptions<unknown, Error, unknown, unknown>,
  'mutationFn'
>;

export const useNotificationRead = ({ ...props }: Props) => {
  return useMutation({
    ...props,
    mutationFn: markNotificationsAsRead,
  });
};
